/* eslint-disable no-unused-vars */
/* eslint-disable no-undef */
const AP_KEY = 'fMtMaj3_QNrF6QfQb9rK7HZ0V0s7goGe2SVP03Ne12Y'

const platform = new H.service.Platform({ 'apikey': AP_KEY })
const defaultLayers = platform.createDefaultLayers()
const map = new H.Map(document.querySelector('#mapContainer'), defaultLayers.vector.normal.map, {
  center: {
    lat: document.querySelector('#mapContainer').dataset.maxlat,
    lng: document.querySelector('#mapContainer').dataset.minlon
  },
  zoom: 13,
  pixelRatio: window.devicePixelRatio || 1
})
const behavior = new H.mapevents.Behavior(new H.mapevents.MapEvents(map))
const ui = H.ui.UI.createDefault(map, defaultLayers)

/**
 * Creates a new marker and adds it to a group
 * @param {H.map.Group} group       The group holding the new marker
 * @param {H.geo.Point} coordinate  The location of the marker
 * @param {String} html             Data associated with the marker
 */
function addMarkerToGroup (group, coordinate, icon = {}, html = '') {
  const marker = new H.map.Marker(coordinate, icon)
  marker.setData(html)
  group.addObject(marker)
}

/**
 * @param  {H.Map} map
 */
function addMarkersToMap (map) {
  const group = new H.map.Group()
  map.addObject(group)
  if (Object.hasOwn(document.querySelector('#mapContainer').dataset, 'markers')) {
    const markers = JSON.parse(document.querySelector('#mapContainer').dataset.markers)
    if (Array.isArray(markers)) {
      markers.forEach(marker => {
        const adMarker = new H.map.Marker(marker)
        group.addObject(adMarker)
      })
    } else {
      group.addObject(new H.map.Marker(markers))
    }

    if (markers.length > 1) {
      map.getViewModel().setLookAtData({
        bounds: group.getBoundingBox()
      })
    }
  } else {
    const icon = new H.map.Icon('/img/favicon.ico')
    group.addEventListener('tap', function (event) {
      const bubble = new H.ui.InfoBubble(event.target.getGeometry(), {
        content: event.target.getData()
      })
      ui.addBubble(bubble)
    }, false)
    addMarkerToGroup(group, { lat: document.querySelector('#mapContainer').dataset.lat, lng: document.querySelector('#mapContainer').dataset.lng }, { icon: icon }, document.querySelector('#mapContainer').dataset.title)
  }
}

window.addEventListener('resize', () => map.getViewPort().resize())
window.addEventListener('load', function () {
  addMarkersToMap(map)
})
